import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { AdminAPI } from '@shared/types/api';

/**
 * Hook to fetch dashboard aggregate metrics (admin only)
 */
export function useAdminDashboardMetrics() {
  return useQuery({
    queryKey: ['admin-dashboard-metrics'],
    queryFn: async (): Promise<AdminAPI.GetDashboardMetricsResponse> => {
      return api.get('/admin/dashboard/metrics');
    },
  });
}

/**
 * Hook to fetch enhanced dashboard stats (users per city, bookings, signups)
 */
export function useAdminDashboardStats() {
  return useQuery({
    queryKey: ['admin-dashboard-stats'],
    queryFn: async (): Promise<AdminAPI.GetDashboardStatsResponse> => {
      return api.get('/admin/dashboard/stats');
    },
  });
}

